import { useCallback, useState } from 'react';

/**
 * For details that open and close with a motion: they are rendered from the
 * moment they open until the closing motion has ended.
 */
export function useRenderedWhileOpen(open: boolean) {
  const [rendered, setRendered] = useState(open);
  if (open && !rendered) setRendered(true);
  const onSettled = useCallback((settledOpen: boolean) => {
    if (!settledOpen) setRendered(false);
  }, []);
  return { rendered, onSettled };
}
